module.exports = __webpack_public_path__ + "img/lifting-station-sm.72491e63.svg";